const SeparatorSelect = ({
  strings: {
    newline,
    comma,
    tab,
    space,
    twoSpaces,
    array,
    arrayQuoted,
    separatorLabel,
  },
  value,
  onChange,
}) => (
  <div className="input-group mb-3">
    <div className="input-group-prepend">
      <label className="input-group-text">{separatorLabel}</label>
    </div>
    <select
      value={value}
      className="form-control"
      id="seperatorSelect"
      onChange={({ target: { value } }) => onChange(value)}
    >
      <option value="newline">{newline}</option>
      <option value="comma">{comma}</option>
      <option value="tab">{tab}</option>
      <option value="space">{space}</option>
      <option value="twoSpaces">{twoSpaces}</option>
      <option value="array">{array}</option>
      <option value="arrayQuoted">{arrayQuoted}</option>
    </select>
  </div>
);

export default SeparatorSelect;
